import MargemContribuicao from '../../spa/margem-roi/MargemContribuicao';

export default {
  path: 'margem-contribuicao',
  name: 'margem-contribuicao',
  component: MargemContribuicao,
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/config/router/margem-contribuicao.js